import { useEffect } from "react";

const PAGE_TITLE = "Privacy Policy | Accent Productions";

/**
 * Ported from web/src/app/privacy/page.tsx (Next.js App Router).
 *
 * - next/metadata export -> document.title effect (SEO deferred).
 * - Pure content page, no Next-specific APIs.
 */
export default function PrivacyPage() {
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <div className="max-w-prose mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-8">Privacy Policy</h1>

      <div className="space-y-10 text-gray-600">
        {/* Information We Hold */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">Information We Hold</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">What We Collect</h3>
              <p>We collect names, email addresses, phone numbers, event details, and payment references necessary to provide our services.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Why We Collect It</h3>
              <p>To provide event services, coordinate contractors, process payments, and send relevant communications about your booking.</p>
            </section>
          </div>
        </div>

        {/* How We Manage It */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">How We Manage It</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Storage</h3>
              <p>Your data is stored securely via Supabase (cloud database) and Google Workspace. We take reasonable steps to protect it from unauthorised access.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Sharing</h3>
              <p>We share relevant event details with contractors assigned to your job. We do not sell your data to third parties.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Retention</h3>
              <p>Data is retained for 7 years for tax and legal purposes, then deleted.</p>
            </section>
          </div>
        </div>

        {/* Your Rights & Contact */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">Your Rights & Contact</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Your Rights</h3>
              <p>Under the NZ Privacy Act 2020, you can request access to, correction of, or deletion of your personal information by emailing <a href="mailto:hello@accent-productions.co.nz" className="underline cursor-pointer">hello@accent-productions.co.nz</a>.</p>
            </section>
          </div>
        </div>

        <p className="text-sm text-gray-400 pt-4">Last updated: April 2026</p>
      </div>
    </div>
  );
}
